import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route, Switch, Link, NavLink} from 'react-router-dom';
import HomePage from './homepage';
import Register from './register';
import Login from './login'
import CreateAccount from './create_account'
import UserMenu from './user_menu'
import ReportingDashboard from './reporting_dashboard'
import Reporting_Dashboard_01312024 from './reporting_dashboard_01312024'
import ReportingDashboard_test from './reporting_dashboard_test'
import ReportingDashboard_test3 from './reporting_dashboard_test3'
import camera_setup from './camera_setup'
import HomePage2 from './homepage2'
import modify_device_settings from './modify_device_settings'
import image_upload from './image_upload'


const AppRouter = () => (

    <BrowserRouter>
    <div>
    <Switch>
        <Route path="/" component={HomePage} exact={true} />
        <Route path="/register" component={Register} exact={true}/>
        <Route path="/login" component={Login} exact={true}/>
        <Route path="/create_account" component={CreateAccount} exact={true}/>
        <Route path="/user_menu" component={UserMenu} exact={true}/>
        <Route path="/reporting_dashboard" component={ReportingDashboard} exact={true}/>
        <Route path="/reporting_dashboard_test" component={ReportingDashboard_test} exact={true}/>
        <Route path="/reporting_dashboard_01312024" component={Reporting_Dashboard_01312024} exact={true}/>
        <Route path="/reporting_dashboard_test3" component={ReportingDashboard_test3} exact={true}/>
        <Route path="/homepage2" component={HomePage2} exact={true}/>
        <Route path="/camera_setup" component={camera_setup} exact={true}/>
        <Route path="/modify_device_settings" component={modify_device_settings} exact={true}/>
        <Route path="/image_upload" component={image_upload} exact={true}/>

    </Switch>
    </div>
    </BrowserRouter>

);

export default AppRouter
